import { RoomData } from '@/editor/data/room/Room';
import { BaseManager } from './BaseManager';
import CeilEntity from '@/editor/entities/ceilEntity';
import { globalStores } from '@/editor/stores';

export class CeilManager extends BaseManager<RoomData> {
  constructor() {
    super(CeilEntity);
  }

  override update() {
    const roomDatas = globalStores.roomStore.getRoomDatas();
    super.update(roomDatas);
  }

  forceUpdate() {
    const roomDatas = globalStores.roomStore.getRoomDatas();
    super.update(roomDatas, true);
  }
}
